import React from 'react';
import { useRoomReactionsControl } from 'features/toolbar/toolbar/controls/room-reactions/useRoomReactionsControl';
import MobileMenuItem from 'features/toolbar/toolbar/mobile/MobileMenuItem';
import { MobileMenuItemWrapperProps } from 'features/toolbar/types';
import { openModal } from 'features/modal/modalSlice';
import { useAppDispatch } from 'store/hooks';

const RoomReactionsControlMobile = ({ onClick }: MobileMenuItemWrapperProps) => {
  const dispatch = useAppDispatch();

  const { isFeatureAvailable, label, icon } = useRoomReactionsControl();

  if (!isFeatureAvailable) {
    return null;
  }

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    onClick?.(event);
    dispatch(openModal('roomReactions'));
  };

  return (
    <MobileMenuItem id="room-reactions-control" icon={icon} onClick={handleClick}>
      {label}
    </MobileMenuItem>
  );
};

export default RoomReactionsControlMobile;
